<div class="row" *ngIf="fascicoli?.length > 0" aria-live="polite">
    <div class="col-12">
        <table class="table">
            <caption class="sr-only">Lista Fascicoli</caption>
            <thead>
                <tr>
                <th scope="col" class="col-xs-2">Numero ruolo</th>
                <th scope="col" class="col-xs-3">Anno ruolo</th>
                <th scope="col" class="col-xs-3">Sezione</th>
                <th scope="col" class="col-xs-3">Giudice</th>
                <th scope="col" class="col-xs-1">
                    <span class="sr-only">Azioni</span>
                </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let fascicolo of currentFascicoli">
                <td class="col-xs-2 cell">{{ replaceNull(fascicolo.numeroRuolo) }}</td>
                <td class="col-xs-3 cell">{{ replaceNull(fascicolo.annoRuolo) }}</td>
                <td class="col-xs-3 cell">{{ replaceNull(fascicolo.sezione) }}</td>
                <td class="col-xs-3 cell">{{ replaceNull(fascicolo.giudice) }}</td>

                <td class="col-xs-1">
                    <button
                    type="button"
                    class="btn btn-link p-0"
                    (click)="viewFascicoloModal(fascicolo)"
                    [attr.aria-label]="'Visualizza fascicolo anonimo'">
                    <span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span>
                    <span class="sr-only">
                        Visualizza fascicolo anonimo
                    </span>
                    </button>

                </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<div class="card-pagination">
    <app-pagination [resetCurrentPage]="resetCurrentPage" [totalItems]="fascicoli != undefined ? fascicoli.length : 0"
        (refreshEvent)="onRefresh($event)">
    </app-pagination>
</div>

<div *ngIf="fascicoli && fascicoli.length === 0" class="row" aria-live="polite">
    <div class="col-sm-12 no-result">
        La consultazione non ha prodotto risultati
    </div>
</div>